export const CAPACITY_RETRY_DELAYS_MS = [3000, 5000, 8000, 10000, 10000, 10000];

export const CAPACITY_MESSAGE = 'Your connection is taking longer than usual. Please wait a moment and try again.';

export const CAPACITY_STATUSES = [502, 503];

export const isCapacityError = (error) => CAPACITY_STATUSES.includes(error?.response?.status);

export const isTransientError = (error) =>
    !isCapacityError(error) &&
    (error?.response ? error.response.status >= 500 || error.response.status === 429 : Boolean(error?.request));

export const withNeutralCapacityMessage = (error) => {
    if (isCapacityError(error) && error.response) {
        const data = error.response.data;
        error.response.data =
            data && typeof data === 'object' ? { ...data, message: CAPACITY_MESSAGE } : { message: CAPACITY_MESSAGE };
    }
    return error;
};

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const withCapacityRetry = async (request, isRetryable = isCapacityError) => {
    for (let attempt = 0; ; attempt++) {
        try {
            return await request();
        } catch (error) {
            if (!isRetryable(error)) throw error;
            if (attempt >= CAPACITY_RETRY_DELAYS_MS.length) throw withNeutralCapacityMessage(error);
            await wait(CAPACITY_RETRY_DELAYS_MS[attempt]);
        }
    }
};
